export default "__VITE_ASSET__o$8_DMEC__"